// extracted by mini-css-extract-plugin
module.exports = {"student":"AddExistingStudents_student__2SIjs","studentMain":"AddExistingStudents_studentMain__3cN1w"};